import DailyOther from "./DailyOther";

export default DailyOther;